import axios from '@/utils/axios'
import {downloadFile} from '@/utils'

export const APP_CODE = 'e-commerce';
export const SUB_APP_CODE = 'ec-pc-new';

// 上传
function upload(url, fileData, params = {}, otherData = {}) {
  const formData = new FormData();

  if (Array.isArray(fileData)) {
    fileData.forEach((item) => formData.append('file', item, item.name));
  } else {
    formData.set('file', fileData, fileData.name);
  }

  for (const [key, value] of Object.entries(otherData)) {
    if (key) {
      formData.append(key, value);
    }
  }
  
  return axios.post(url, formData, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 按照模块，export对象，避免命名冲突；也可直接export方法，优先选择export对象
// 定义方法时，描述参数结构，传递参数后进行结构，而不要直接传递data或者params对象
// 示例：
export const demo = {
  uploadFile(file) {
    return upload('/xxxx', file);
  },
  downloadFile(fileId) {
    return axios.get(`/design-file-share/file/download/${fileId}`, {
        responseType: 'blob'
      })
      .then((response) => {
        downloadFile(response);
      });
  },
  getUserList(data) {
    return axios.post('/qu-platform-manage-api/user/list', data);
  }
};

export const common = {
  login({userName, password}) {
    return axios.post('/qu-platform-auth-api/auth/tokenWithUser', {
      userName,
      password,
      appCode: SUB_APP_CODE,
      loginType: 1
    });
  },
  // login({userName, password}) {
  //   return axios.post('/qu-platform-auth-api/auth/tokenWithAD', {
  //     userName,
  //     password,
  //     appCode: SUB_APP_CODE
  //   });
  // },
  importFile(file, taskDTO) {
    return upload('/qu-platform-excel-api/excel/import/task', file, {}, {
      taskDTO: JSON.stringify(taskDTO)
    })
  },
  getMenus() {
    return axios.post('/qu-platform-auth-api/auth/acl/tree/user', {}, {
      params: {
        appCode: APP_CODE,
        subAppCode: SUB_APP_CODE
      }
    })
  },
  checkPermission(account) {
    return axios.post('/qu-platform-auth-api/user/release/auth', {
      account,
      appCode: SUB_APP_CODE
    });
  },
  doExport(reportName, paramMap) {
    return axios.post('/qu-platform-excel-api/excel/export/task', {
      appCode: SUB_APP_CODE,
      reportName,
      paramMap
    });
  },
  // 获取按钮的权限列表
  getButtonPermission() {
    return axios.post('/qu-platform-auth-api/auth/acl/list/user/button', {}, {
      params: {
        subAppCode: SUB_APP_CODE,
        containTab: true
      }
    });
  },
  newProductStatics() {
    return axios.post('/ec-goods-new-api/msgNotice/newProductStatics');
  },
  getUserInfo() {
    return axios.get('/qu-platform-auth-api/user/home/user/info');
  },
  // 我的应用
  getMyApps() {
    return axios.get('/qu-platform-auth-api/myApp/list');
  }
};

